import React from "react";
import {
  Box,
  Autocomplete,
  TextField,
  Popper,
  useMediaQuery,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { darkTheme, lightTheme } from "../../theme/Theme";
import { autoCompletStyles } from "../../utils/FieldStyles/FieldStyles";
import { setSelectedPage } from "../../slices/uploadHistoryslice";
import { Dropdown as CustomDropdown } from "pepsico-ds";
export default function UploadDropDown() {
  const dispatch = useDispatch();
  const options = ["Pending approvals", "History"].map((item, idx) => ({
    id: idx + 1,
    displayText: item,
  }));
  const isMobile = useMediaQuery("(max-width:600px)");
  const { select } = useSelector((store) => store.uploadHistory);

  const HandleChange = (event, newValue) => {
    newValue && dispatch(setSelectedPage(newValue));
  };
  const isDarkTheme = useSelector((state) => state.theme);
  console.log("Dropdown selected:", select); // In UploadDropDown
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        maxWidth: "400px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "var(--Spacing-spacing-8, 8px)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          maxWidth: "400px",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "var(--Spacing-spacing-8, 8px)",
        }}
      >
        <CustomDropdown
          childList={options}
          isDark={isDarkTheme}
          setSelectedValue={(e) => HandleChange(e, e && e[0]?.displayText)}
          className="admin-dropdown"
          selectedValue={
            options.filter((item) => item.displayText === select) || []
          }
          isClearable={false}
          placeholder="Select One"
          value={select}
        />
      </Box>
    </Box>
  );
}
